import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleUpMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconChevronTriangleUpMedium"><Path d="M11.0456 8.35346C11.5448 7.76363 12.4545 7.76376 12.9538 8.35346L16.8366 12.9423C17.524 13.7547 16.9467 14.9999 15.8825 14.9999H8.11687C7.05296 14.9997 6.47563 13.7546 7.16277 12.9423L11.0456 8.35346Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleUpMedium;
